<template>
  <vgloballayout
    :loading="loading"
    :error="error"
    @reload="getPersonalSettings"
  >
    <div slot="body">
      <h1>Настройки личного кабинета собственника</h1>
      <el-form :model="form" :rules="rules" ref="form" label-position="left">
        <el-row type="flex" justify="space-between m-t-45">
          <el-col :span="11">
            Передача показаний счетчиков

            <el-tooltip class="item" effect="dark" placement="bottom">
              <div slot="content" style="text-align: center">
                Если вы активируете эту функцию, собственники смогут <br />
                передавать показания приборов учета с помощью сервиса<br />
                «Квартплата.онлайн»
              </div>
              <i class="el-icon-question" style="color: #53a8ff"></i>
            </el-tooltip>
          </el-col>
          <el-col :span="11">
            <el-switch
              v-model="form.canInputCountersValues"
              active-color="#13ce66"
              inactive-color="#CCC"
            >
            </el-switch>
          </el-col>
        </el-row>
        <el-row type="flex" justify="space-between m-t-45">
          <el-col :span="11">
            Передача показаний счетчиков с истекшей поверкой
            <el-tooltip class="item" effect="dark" placement="bottom">
              <div slot="content" style="text-align: center">
                Если вы активируете эту функцию, собственники смогут передавать
                <br />
                показания приборов учета даже по истечении срока поверки
              </div>
              <i class="el-icon-question" style="color: #53a8ff"></i>
            </el-tooltip>
          </el-col>
          <el-col :span="11">
            <el-switch
              v-model="form.canInputCountersValuesWhenUnverified"
              active-color="#13ce66"
              inactive-color="#CCC"
            >
            </el-switch>
          </el-col>
        </el-row>

        <el-row type="flex" justify="space-between m-t-45">
          <el-col :span="11">
            Разрешена передача показаний по закрытым л/с
            <el-tooltip class="item" effect="dark" placement="bottom">
              <div slot="content" style="text-align: center">
                Если вы активируете эту функцию, собственники смогут передавать<br/>
                показания приборов учета даже при закрытом лицевом счете
              </div>
              <i class="el-icon-question" style="color: #53a8ff"></i>
            </el-tooltip>
          </el-col>
          <el-col :span="11">
            <el-switch
              v-model="form.canInputCountersValuesWhenAccountClosed"
              active-color="#13ce66"
              inactive-color="#CCC"
            >
            </el-switch>
          </el-col>
        </el-row>

        <el-row type="flex" justify="space-between m-t-45">
          <el-col :span="11">
            Ограничение даты передачи показаний
            <el-tooltip class="item" effect="dark" placement="bottom">
              <div slot="content" style="text-align: center">
                Ограничивает передачу показаний установленным периодом и <br />
                активирует автоматические push-уведомления: в первый и последний
                <br />
                день сервис сообщит собственникам о необходимости отправки
                <br />
                показаний счетчиков.
              </div>
              <i class="el-icon-question" style="color: #53a8ff"></i>
            </el-tooltip>
          </el-col>
          <el-col :span="11">
            <el-row type="flex">
              <el-col :span="24">
                <el-switch
                  v-model="form.limitingSendCounterValues"
                  active-color="#13ce66"
                  inactive-color="#CCC"
                  class="p-r-10"
                  @change="changeLimitingSendCounterValues"
                >
                </el-switch>
              </el-col>
            </el-row>
          </el-col>
        </el-row>

        <el-row
          v-if="form.limitingSendCounterValues"
          type="flex"
          justify="space-between m-t-45"
          align="middle"
        >
          <el-col :span="5" />
          <el-col :span="11">Передача возможна с</el-col>
          <el-col>
            <el-select
              v-model="form.sendCountersValuesFromDay"
              placeholder="С"
              style="width: 70px;"
              class="p-r-10"
              :disabled="!form.limitingSendCounterValues"
            >
              <el-option
                v-for="item in 30"
                :key="item"
                :label="item"
                :value="item"
              />
            </el-select>
            <span class="p-r-10">по</span>
            <el-select
              v-model="form.sendCountersValuesToDay"
              placeholder="ПО"
              style="width: 70px;"
              :disabled="!form.limitingSendCounterValues"
            >
              <el-option
                v-for="item in 31"
                :key="item"
                :label="item"
                :value="item"
              />
            </el-select>
          </el-col>
        </el-row>

        <el-row type="flex" justify="space-between m-t-45" v-if="getOrganizationInfo.userRequestTarget !== 3">
          <el-col :span="11">
            Передача заявок
            <el-tooltip class="item" effect="dark" placement="bottom">
              <div slot="content" style="text-align: center">
                Если вы активируете эту функцию, собственники смогут
                <br />отправлять вам заявки с помощью сервиса
                «Квартплата.онлайн».
              </div>
              <i class="el-icon-question" style="color: #53a8ff"></i>
            </el-tooltip>
          </el-col>
          <el-col :span="11">
            <el-switch
              v-model="form.canSendRequest"
              active-color="#13ce66"
              inactive-color="#CCC"
            >
            </el-switch>
          </el-col>
        </el-row>

        <el-form-item
          class="m-b-10 phone-org_request"
          label="Номера телефона для связи с организацией"
          prop="phoneForRequests"
          v-if="!form.canSendRequest"
        >
          <div style="width: 200px">
            <el-input
              size="small"
              v-model="form.phoneForRequests"
              v-mask="'+7##########'"
              placeholder="+7"
            ></el-input>
          </div>
        </el-form-item>

        <el-row type="flex" justify="end m-t-25">
          <el-button
            type="primary"
            size="mini"
            style="width: 92px"
            :loading="loadingSubmit"
            @click="onSubmit"
            >Сохранить</el-button
          >
        </el-row>
      </el-form>

      <el-divider></el-divider>

      <el-row type="flex" class="row-bg m-t-25" justify="space-between">
        <el-col :span="12">
          <h4>Темы обращений</h4>
        </el-col>
        <el-col :span="12" class="m-t-15" v-if="getOrganizationInfo.userRequestTarget !== 3">
          <CreateSubject />
        </el-col>
      </el-row>
      <el-table :data="getUserRequestSubjects" style="width: 100%">
        <el-table-column label="id" prop="id"> </el-table-column>

        <el-table-column label="Наименование" prop="name"> </el-table-column>

        <el-table-column label="Email" prop="email"> </el-table-column>

        <el-table-column align="right">
          <template slot-scope="scope">
            <DeleteSubject :index="scope.$index" :id="scope.row.id" />
          </template>
        </el-table-column>
      </el-table>
    </div>
  </vgloballayout>
</template>

<script>
import DeleteSubject from "./modal/delete-subject";
import CreateSubject from "./modal/create-subject";
import { mapGetters } from "vuex";

export default {
  data() {
    let validatePhone = (rule, value, callback) => {
      let test = /(\+7|8)[- _]*\(?[- _]*(\d{3}[- _]*\)?([- _]*\d){7}|\d\d[- _]*\d\d[- _]*\)?([- _]*\d){6})/g.test(
        value
      );
      if (value == "") {
        callback(new Error("Заполните телефон"));
      } else if (!test) {
        callback(new Error("Заполните корректно телефон"));
      } else {
        callback();
      }
    };

    return {
      loading: false,
      loadingSubmit: false,
      error: false,
      form: {
        canInputCountersValues: true,
        canSendRequest: true,
        phoneForRequests: "",
        canPrintPaymentDocument: true,
        limitingSendCounterValues: true,
        sendCountersValuesFromDay: 25,
        sendCountersValuesToDay: 30,
        showDebtWarning: false,
        debtWarning: "",
        debtWarning2: "",
        canInputCountersValuesWhenUnverified: false,
        canInputCountersValuesWhenAccountClosed: false,
      },
      rules: {
        phoneForRequests: [{ validator: validatePhone, trigger: "blur" }]
      },
      tableData: []
    };
  },
  mounted() {
    this.getPersonalSettings();
    this.userRequestSubjects();
  },
  computed: {
    ...mapGetters(["getUserRequestSubjects", "getOrganizationInfo"])
  },
  methods: {
    async onSubmit() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          this.loadingSubmit = true;

          try {
            //this.form.phoneForRequests = this.form.phoneForRequests ? this.form.phoneForRequests.replace(/\s+/g,'') : null
            await this.$store.dispatch("setPersonalSettings", this.form);
            this.$message({
              message: " Настройки обновлены",
              type: "success"
            });
          } catch (e) {
            this.$ErrorsMod(e);
          }

          this.loadingSubmit = false;
        }
      });
    },

    changeLimitingSendCounterValues() {
      if (this.form.limitingSendCounterValues) {
        this.form.sendCountersValuesFromDay = 25;
        this.form.sendCountersValuesToDay = 30;
      } else {
        this.form.sendCountersValuesFromDay = null;
        this.form.sendCountersValuesToDay = null;
      }
    },

    async getPersonalSettings() {
      this.loading = true;
      this.error = false;

      try {
        let query = await this.$store.dispatch("getPersonalSettings");

        this.form = { ...query };
      } catch (e) {
        this.error = this.$ErrorsMod(e);
      }

      this.loading = false;
    },

    async userRequestSubjects() {
      this.loading = true;
      this.error = false;

      try {
        await this.$store.dispatch("userRequestSubjects");
      } catch (e) {
        this.error = this.$ErrorsMod(e);
      }

      this.loading = false;
    }
  },
  components: {
    DeleteSubject,
    CreateSubject
  }
};
</script>

<style scoped>
.phone-org_request {
  margin-top: 20px;
  margin-bottom: 60px;
  border-bottom: 1px dashed #ccc;
  padding: 0 0 25px 0;
}

::v-deep .el-table .cell {
  padding-right: 0;
}
</style>
